__turbopack_context__.v({
  "actions": "ProfileCard-module-scss-module__uIwhdq__actions",
  "body": "ProfileCard-module-scss-module__uIwhdq__body",
  "card": "ProfileCard-module-scss-module__uIwhdq__card",
  "cta": "ProfileCard-module-scss-module__uIwhdq__cta",
  "description": "ProfileCard-module-scss-module__uIwhdq__description",
  "eyebrow": "ProfileCard-module-scss-module__uIwhdq__eyebrow",
  "eyebrowIcon": "ProfileCard-module-scss-module__uIwhdq__eyebrowIcon",
  "eyebrowText": "ProfileCard-module-scss-module__uIwhdq__eyebrowText",
  "image": "ProfileCard-module-scss-module__uIwhdq__image",
  "meta": "ProfileCard-module-scss-module__uIwhdq__meta",
  "title": "ProfileCard-module-scss-module__uIwhdq__title",
});
